// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search-suggestions_wrapper__EQRjE","title":"search-suggestions_title__H1Vri","suggestion":"search-suggestions_suggestion__S2wtN"};